import {HERDS_MESSAGES} from "apps/BWW_TRIVIA/modules/utils/trivia";
import {get} from "lodash";
import {globalError} from "modules/actions/errors";
import {showGameMessage} from "modules/actions/game_message";
import {
	changeCaptainFailed,
	changeCaptainSuccess,
	createTeamFailed,
	createTeamSuccess,
	fetchTeamFailed,
	fetchTeamSuccess,
	joinToTeamFailed,
	joinToTeamSuccess,
	leaveFromTeamFailed,
	leaveFromTeamSuccess,
	removePlayerFailed,
	removePlayerSuccess,
	removeTeamFailed,
	removeTeamSuccess,
	reviveTeamFailed,
	reviveTeamSuccess,
	updateTeamFailed,
	updateTeamSuccess
} from "modules/actions/herd";
import {ICreateTeam, IJoinTeam, IPlayer, IRemovePlayer} from 'modules/reducers/herds';
import {getActualGameContest} from "modules/selectors/trivia";
import {ISagaAction} from "modules/types";
import {ApiError, TriviaApi} from "modules/utils/Api";
import {call, put, select} from 'typed-redux-saga';

export const postCreateHerdSaga = function* (action: ISagaAction<ICreateTeam>) {
	try {
		const result = yield* call(TriviaApi.Herds.create, action.payload);
		ApiError.CHECK(result);
		yield put(createTeamSuccess(result.result.team));
		yield put(showGameMessage({
			message: HERDS_MESSAGES.team_created
		}));
	} catch (e: any) {
		yield put(createTeamFailed(e))
		const error = e as Error;
yield put(globalError(error))
	}
}

export const postUpdateHerdSaga = function* (action: ISagaAction<ICreateTeam>) {
	try {
		const result = yield* call(TriviaApi.Herds.create, action.payload);
		ApiError.CHECK(result);
		yield put(updateTeamSuccess(result.result.team));
	} catch (e: any) {
		yield put(updateTeamFailed(e))
		const error = e as Error;
yield put(globalError(error))
	}
}

export const fetchHerdSaga = function* () {
	try {
		const contest = yield* select(getActualGameContest);

		if ( contest?.is_herd ) {
			const result = yield* call(TriviaApi.Herds.fetch);
			ApiError.CHECK(result);
			const team = result.result?.team || null;
			yield put(fetchTeamSuccess(team));
		}
	} catch (e: any) {
		yield put(fetchTeamFailed())
		const error = e as Error;
yield put(globalError(error))
	}
}

export const joinHerdSaga = function* (action: ISagaAction<IJoinTeam>) {
	try {
		const result = yield* call(TriviaApi.Herds.join, action.payload);
		ApiError.CHECK(result);
		yield put(joinToTeamSuccess(result.result.team));
		yield put(showGameMessage({
			message: HERDS_MESSAGES.you_joined
		}));
	} catch (e: any) {
		yield put(showGameMessage({
			color: '#C3470E',
			message: e.message
		}));

		yield put(joinToTeamFailed())
		const error = e as Error;
yield put(globalError(error))
	}
}

export const leaveHerdSaga = function* () {
	try {
		const result = yield* call(TriviaApi.Herds.leave);
		ApiError.CHECK(result);
		yield put(leaveFromTeamSuccess())
	} catch (e: any) {
		yield put(showGameMessage({
			color: '#C3470E',
			message: e.message
		}));
		yield put(leaveFromTeamFailed())
		const error = e as Error;
yield put(globalError(error))
	}
}

export const removePlayerSaga = function* (action: ISagaAction<IRemovePlayer>) {
	try {
		const result = yield* call(TriviaApi.Herds.delete_player, action.payload.id);
		ApiError.CHECK(result);
		yield put(removePlayerSuccess(result.result.team))
	} catch (e: any) {
		yield put(removePlayerFailed(e))
		const error = e as Error;
yield put(globalError(error))
	}
}

export const deleteHerdSaga = function* () {
	try {
		const result = yield* call(TriviaApi.Herds.remove);
		ApiError.CHECK(result);
		yield put(removeTeamSuccess())
	} catch (e: any) {
		yield put(removeTeamFailed(e))
		const error = e as Error;
yield put(globalError(error))
	}
}


export const reviveHerdSaga = function* () {
	try {
		const result = yield* call(TriviaApi.Herds.revive);
		ApiError.CHECK(result);
		yield put(reviveTeamSuccess(result.result.team));

		const players: IPlayer[] = get(result, 'result.team.players', []);
		if ( players.length > 1 ) {
			yield put(showGameMessage({
				message: HERDS_MESSAGES.you_revive_joined
			}));
		} else {
			yield put(showGameMessage({
				message: HERDS_MESSAGES.you_revive_joined_captain
			}));
		}
	} catch (e: any) {
		console.log(e);
		yield put(showGameMessage({
			color: '#C3470E',
			message: e.message
		}));

		yield put(reviveTeamFailed(e))
		const error = e as Error;
yield put(globalError(error))
	}
}

export const postChangeCaptainSaga = function* (action: ISagaAction<number>) {
	try {
		const result = yield* call(TriviaApi.Herds.change_captain, {
			captain_id: action.payload
		});
		ApiError.CHECK(result);

		yield put(changeCaptainSuccess(result.result.team))

	} catch (e: any) {
		yield put(changeCaptainFailed(e))
		const error = e as Error;
yield put(globalError(error))
	}
}
